<template>
<section class="termsBox">

    <h2 class="conTit1 mgt1">
        BMW ServiceCare+<br>
        POWER TRAIN WARRANTY<br>
        제공을 위한 마케팅 활용 동의
    </h2>

    <div class="termsCon">
        <p>BMW ServiceCare+  POWER TRAIN WARRANTY 서비스 제공을 위해 &lt;개인정보 보호법&gt; 등 관련 법률에 따라 아래와 같이 개인정보를 수집, 이용하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여 주시기 바랍니다.</p>
    </div>

    <div>
        <div class="termsCon" id="termsPart1">

            <!-- <h2 class="termsTit">처리자</h2> -->

            <ol class="circleNum contentBox">
                <li>
                    처리자
                    <ol class="numList">
                        <li>- 비엠더블유인슈어런스서비스코리아㈜, 한화손해보험㈜</li>
                    </ol>
                </li>
                <li>
                    제공목적
                    <ol class="numList">
                        <li>- 경품 배송, 시승 등 고객 행사 진행, 신규 이벤트 및 캠페인 안내 등을 위한 우편/이메일/문자 발송, 뉴스레터 및 매거진 발송, 인구 통계학적 특성에 따른 서비스 제공 및 광고 게재</li>
                    </ol>
                </li>
                <li>
                    처리항목
                    <ol class="numList">
                        <li>- 이름, 생년월일, 휴대전화번호, 전자우편주소, 주소, 차량정보(차대번호, 차량번호)</li>
                    </ol>
                </li>
                <li>
                    보유기간
                    <ol class="numList">
                        <li class="sizeUpBold">- 2년</li>
                    </ol>
                </li>

                <div class="contentBoxBottom">
                    위의 마케팅 활용에 대한 동의를 거부할 수 있으며, 동의한 이후에도 언제든지 이를 철회할 수 있습니다. 동의를 거부할 경우 위에 나열된 처리목적에 해당하는 행사 안내 및 진행 등은 제한될 수 있으나, 필수적인 BMW ServiceCare+ 서비스 제공에는 영향을 미치지 않습니다.
                </div>
            </ol>
        </div>
    </div>

</section>
</template>

<script>
export default {
    name: 'TermInsuranceMarketing'
}
</script>

<style lang="scss" scoped>
</style>